export const RGB_REGEX = /^#[A-Fa-f0-9]{6}$/

export const RGBA_REGEX = /^#[A-Fa-f0-9]{8}$/

export const LANG_REGEX = /^[a-z]{2}(-[A-Z]{2})?$/
